import * as React from 'react';
import {
  BaSeIcon,
  BaSeButton,
  BaSeParagraph,
  BaSeSmall2,
  BaSeTheme,
  BaSeLoading,
} from '@base/react';
import {
  DraggerStyled,
  InfoContainer,
  ButtonsWrapper,
  RelativeContainer,
  ImagePositioner,
} from './dragger-styled';
import { useFileDrop } from '../../../hooks/useDrag';

export const Dragger = ({
  image,
  setImage,
  isLoadingImage,
  label,
  sizeImg,
  subLabel,
  isClear,
  // eslint-disable-next-line sonarjs/cognitive-complexity
}) => {
  const inputRef = React.useRef(null);
  const [loadedImage, setLoadedImage] = React.useState(null);
  const { DropBox, HiddenInput, onClick, drag } = useFileDrop(setImage);

  const toBase64 = React.useCallback(
    (file) =>
      new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      }),
    [],
  );

  const handleDelete = React.useCallback(() => {
    setLoadedImage(null);
    setImage(null);
  }, [setImage]);

  const handleChange = React.useCallback(
    (e) => {
      const files = e.target.files;
      if (files.length > 0) {
        setImage(files[0]);
      }
    },
    [setImage],
  );

  React.useEffect(() => {
    if (isClear) handleDelete();
  }, [handleDelete, isClear]);

  React.useEffect(() => {
    if (image) {
      const getBase = async (image) => {
        return await toBase64(image);
      };
      if (typeof image === 'string') {
        return setLoadedImage(image);
      }
      getBase(image)
        .then((data) => {
          setLoadedImage(data);
          return data;
        })
        .catch((error) => {
          console.log(error);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [image]);

  React.useEffect(() => {
    console.log(image);
  }, [image]);

  if (!!isLoadingImage) {
    return <BaSeLoading text="Buscando imagem" />;
  }

  if (!!loadedImage) {
    return (
      <>
        <div style={{ display: 'flex', gap: 4 }}>
          <BaSeParagraph color={BaSeTheme.colors.institucionais.cinzaSebrae45}>
            {label}
          </BaSeParagraph>
          <BaSeParagraph
            isItalic
            color={BaSeTheme.colors.institucionais.cinzaSebrae60}
          >
            {subLabel}
          </BaSeParagraph>
        </div>
        <DraggerStyled hasImage>
          <img src={loadedImage} alt={label} height={100} />
          <ButtonsWrapper>
            <BaSeButton
              value="Trocar"
              size="small"
              leftIcon="refresh-alt"
              onClick={() => inputRef?.current?.click()}
            />
            <input
              style={{ display: 'none' }}
              ref={inputRef}
              type="file"
              accept="image/*"
              className="no-show"
              onChange={handleChange}
            />
            <BaSeButton
              leftIcon="trash-alt"
              size="small"
              value="Excluir"
              onClick={() => handleDelete()}
            />
          </ButtonsWrapper>
        </DraggerStyled>
      </>
    );
  }

  return (
    <RelativeContainer>
      <div style={{ display: 'flex', gap: 4 }}>
        <BaSeParagraph color={BaSeTheme.colors.institucionais.cinzaSebrae45}>
          {label}
        </BaSeParagraph>
        <BaSeParagraph
          isItalic
          color={BaSeTheme.colors.institucionais.cinzaSebrae60}
        >
          {subLabel}
        </BaSeParagraph>
      </div>
      <RelativeContainer>
        <ImagePositioner>
          <BaSeIcon
            name="file-plus-alt"
            description="Upload de produtos"
            size={48}
            color={BaSeTheme.colors.institucionais.cinzaSebrae90}
          />
        </ImagePositioner>
      </RelativeContainer>
      <DropBox>
        <DraggerStyled drag={drag}>
          <HiddenInput />
          <BaSeButton value="Escolher arquivo" onClick={onClick} />
          <InfoContainer>
            <BaSeParagraph
              color={BaSeTheme.colors.institucionais.cinzaSebrae60}
            >
              Ou arraste a imagem aqui para adicioná-la
            </BaSeParagraph>
            <BaSeSmall2 color={BaSeTheme.colors.institucionais.cinzaSebrae60}>
              Tamanho da imagem de 1mb
            </BaSeSmall2>
            <BaSeSmall2 color={BaSeTheme.colors.institucionais.cinzaSebrae60}>
              {`Proporção de ${sizeImg}`}
            </BaSeSmall2>
          </InfoContainer>
        </DraggerStyled>
      </DropBox>
    </RelativeContainer>
  );
};
